<div class="gray-bg-rounded">
  <div class="col-12">
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 310px)"
      [size]="'small'"
      [resizableColumns]="true"
      [value]="inventoryPurchaseLines"
      [(selection)]="selectedGoods"
      styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      dataKey="id"
      editMode="row"
      selectionMode="multiple"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <!-- <th style="width: 3rem"></th>
        <th></th>
        <th class="col-center" style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
          <th class="number">#</th>
          <th class="vendor-sku">Item Number</th>
          <th class="description">Description</th>
          <!-- <th class="description">Item Name</th> -->
          <th class="quantity">Ship Date</th>
          <th class="sell">In-hands Date</th>
          <th class="sell-total">Firm</th>
          <th class="net">Configuration</th>
          <th class="net">Color</th>
          <th class="net">Style</th>
          <th class="net">Size</th>
          <th class="net">Site</th>
          <th class="net">Warehouse</th>
          <th class="net">Location</th>
          <!-- <th class="net">Serial Number</th> -->
          <th class="net">Arrival status</th>
          <!-- <th class="net">License Plate</th> -->
          <!-- <th class="net">Owner</th> -->
          <th class="net">Quantity</th>
          <th class="net">NET</th>
          <th class="net">NET TOTAL</th>
          <th class="net">Mode of Delivery</th>
          <th class="net">JNI Frieght Account</th>
          <th class="net">Account Number</th>
          <th class="net">Factory Notes</th>
          <th class="net">Trackable</th>
          <th class="net">Currency</th>
          <th class="net">Vendor</th>
          <th class="net">Vendor Name</th>
          <th class="net">PO Number</th>
          <th class="net">Delivery Selection</th>
          <th class="net">Finalized</th>
          <th class="net">Ship To Address</th>
          <th class="net">Line Group</th>
          <th class="net">Recieve Quantity</th>
          <th class="net">Excluded</th>
          <th class="net">Parent</th>
          <th class="net">Deliver Remainder</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-finishedGoods
        let-editing="editing"
        let-ri="rowIndex"
        let-rowIndex="rowIndex">
        <ng-container>
          <tr
            [pReorderableRow]="rowIndex"
            class="p-selectable-row"
            [pEditableRow]="finishedGoods"
            [pSelectableRow]="finishedGoods">
            <!-- <td>
            <span class="pi pi-bars" [pReorderableRowHandle]="rowIndex"></span>
          </td> -->
            <!-- <td style="text-align: center"> -->
            <!-- <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text"
              ></button> -->
            <!-- <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"
              ></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"
              ></button> -->
            <!-- </td> -->
            <!-- <td class="col-center">
              <p-tableCheckbox
              [pSelectableRow]="finishedGoods"
                [value]="finishedGoods"
              ></p-tableCheckbox>
            </td> -->
            <td class="number">
              <span class="link line-number">{{
                finishedGoods.lineNumberD365
              }}</span>
            </td>
            <td class="vendor-sku">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    style="width: 35rem"
                    [(ngModel)]="finishedGoods.itemNumberD365"
                    required />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.itemNumberD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="description"
              [ngClass]="{
                'trimmeddescription trimmedby50char': descriptionCharacterCond,
              }">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    style="width: 15rem"
                    [(ngModel)]="finishedGoods.lineDescriptionD365"
                    required />
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    descriptionCharacterCount(finishedGoods.lineDescriptionD365)
                  }}
                  {{ finishedGoods.lineDescriptionD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <!-- <td class="description">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="finishedGoods.productNameD365"
                  style="width: 15rem"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ finishedGoods.productNameD365 }}
              </ng-template>
            </p-cellEditor>
          </td> -->
            <td class="sell">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.requestedShippingDateD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.requestedShippingDateD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    finishedGoods.requestedShippingDateD365 | date: "MM-dd-yyyy"
                  }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="sell">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.requestedDeliveryDateD365"
                >
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    pInputText
                    id="bacUserDefaultSelectionId"
                    [(ngModel)]="finishedGoods.requestedDeliveryDateD365"
                    [options]="dropdown">
                    <!-- <ng-template let-item #item>
                        {{ item.personnelNumber }} : {{ item.projectName }}
                      </ng-template> -->
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    finishedGoods.requestedDeliveryDateD365 | date: "MM-dd-yyyy"
                  }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.rsmFirmD365"
                >
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> --><p-select
                    pInputText
                    [(ngModel)]="finishedGoods.rsmFirmD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.rsmFirmD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.configD365"
                >
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.configD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.configD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.colorD365"
                >
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.colorD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.colorD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.styleD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.styleD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.styleD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.sizeD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->

                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.sizeD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.sizeD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="purchaseOrderHeader.siteD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.siteD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ purchaseOrderHeader?.siteD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="purchaseOrderHeader.warehouseD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.warehouseD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ purchaseOrderHeader?.warehouseD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.wmsLocationD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.wmsLocationD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.wmsLocationD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.arrivalStatusD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.arrivalStatusD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.arrivalStatusD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.orderedPurchaseQuantityD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.orderedPurchaseQuantityD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.orderedPurchaseQuantityD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.purchasePriceD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.purchasePriceD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.purchasePriceD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.lineAmountD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.lineAmountD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.lineAmountD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.deliveryModeIdD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.deliveryModeIdD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.deliveryModeIdD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.freightAccountNumD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.freightAccountNumD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.freightAccountNumD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.freightAccountNumD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.freightAccountNumD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.freightAccountNumD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="description"
              [ngClass]="{
                'trimmeddescription trimmedby50char': descriptionCharacterCond,
              }">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    style="width: 15rem"
                    [(ngModel)]="finishedGoods.factoryNotesD365"
                    required />
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    descriptionCharacterCount(finishedGoods.factoryNotesD365)
                  }}
                  {{ finishedGoods.factoryNotesD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.trackableD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.trackableD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.trackableD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.currencyCodeD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.currencyCodeD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.currencyCodeD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.vendorIdD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.vendorIdD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.vendorIdD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.vendorNameD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.vendorNameD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.vendorNameD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.poNumberD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.poNumberD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.poNumberD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.deliverySelectionD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.deliverySelectionD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.deliverySelectionD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.finalPoD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.finalPoD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.finalPoD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.shipToAddressD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.shipToAddressD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.shipToAddressD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.lineGroupD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.lineGroupD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.lineGroupD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.receivedQty">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.receivedQty"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.receivedQty | number: "1.2-2" }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.excludedD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.excludedD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.excludedD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.parentD365">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.parentD365"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.parentD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="net">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <!-- <ng-select
                  class="p-0"
                  id="currency"
                  style="width: auto"
                  [(ngModel)]="finishedGoods.deliverReminder">
                  <ng-option *ngFor="let com of dropdown" [value]="com">
                    {{ com }}
                  </ng-option>
                </ng-select> -->
                  <p-select
                    class="p-0"
                    pInputText
                    [(ngModel)]="finishedGoods.deliverReminder"
                    [options]="dropdown">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.deliverReminder }}
                </ng-template>
              </p-cellEditor>
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No line item found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
